/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { ModuleVersionCreateRequestSourceVersion } from './moduleVersionCreateRequestSourceVersion';

/**
 * How to create/filter for modules
 */
export interface ModuleVersionCreateRequest {
  sourceVersion?: ModuleVersionCreateRequestSourceVersion;
}
